// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.llog51SKm0wNnC8GGK3Q{text-align:center;display:flex;flex-direction:column;overflow:hidden;height:100%}.llog51SKm0wNnC8GGK3Q.iIvG8OEVIHd8MnvTrSwX .TMREYZNxZ4a4pr4CfKTY>*>*>*>*{font-size:12px !important;padding-top:3px;padding-bottom:3px}.llog51SKm0wNnC8GGK3Q.iIvG8OEVIHd8MnvTrSwX .TMREYZNxZ4a4pr4CfKTY>*>*>*>div>span{font-size:12px !important;padding-top:3px;padding-bottom:3px;border:0}.llog51SKm0wNnC8GGK3Q.iIvG8OEVIHd8MnvTrSwX .h_85f3eeJg7oaWbYDQbt>*>*>*>*{font-size:12px !important;padding:3px 10px}.llog51SKm0wNnC8GGK3Q h3{margin:0 0 15px;text-align:center;font-size:16px;font-style:normal;font-weight:700;line-height:116.5%}.llog51SKm0wNnC8GGK3Q .pHIyPcOSvX720MurU6wJ{text-align:center}.llog51SKm0wNnC8GGK3Q .pHIyPcOSvX720MurU6wJ i{color:var(--color-515-granat)}.llog51SKm0wNnC8GGK3Q .Ja6xRY24MmuuZCFjq6tw{padding:15px 0 0;border-top:1px solid var(--color-515-zimnyszary)}.llog51SKm0wNnC8GGK3Q .TMREYZNxZ4a4pr4CfKTY{flex:6 6 auto}.llog51SKm0wNnC8GGK3Q .h_85f3eeJg7oaWbYDQbt{margin-bottom:15px;flex:5 5 auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `llog51SKm0wNnC8GGK3Q`,
	"small": `iIvG8OEVIHd8MnvTrSwX`,
	"board": `TMREYZNxZ4a4pr4CfKTY`,
	"tilesLibrary": `h_85f3eeJg7oaWbYDQbt`,
	"hr": `pHIyPcOSvX720MurU6wJ`,
	"controls": `Ja6xRY24MmuuZCFjq6tw`
};
export default ___CSS_LOADER_EXPORT___;
